import script from "./Siding12Doors.vue?vue&type=script&setup=true&lang=js"
export * from "./Siding12Doors.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__